/**
 * @generated SignedSource<<b169f559537c0e0b073c13d540edbc9f>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type HubService = "CLICK_N_COLLECT" | "INSTANT_BUY" | "LOCK_B2B" | "LOCK_B2C" | "ONEDELIVERY" | "RAFFLE" | "SHOP_N_COLLECT" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type clientResolversAvailableServicesFragment$data = {
  readonly meta: {
    readonly services: ReadonlyArray<HubService>;
  } | null | undefined;
  readonly slug: string;
  readonly " $fragmentType": "clientResolversAvailableServicesFragment";
};
export type clientResolversAvailableServicesFragment$key = {
  readonly " $data"?: clientResolversAvailableServicesFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"clientResolversAvailableServicesFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "clientResolversAvailableServicesFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "HubMeta",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "services",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Hub",
  "abstractKey": null
};

(node as any).hash = "78c4fb459d9094d75bfe95f23e9d4969";

export default node;
